import React from "react";
import './Nav.css';
import 'bootstrap/js/dist//util.js';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import {AppConfig} from "../../AppConfig";
import Cookies from 'universal-cookie';
import {globalSession} from "../../module/Session";

const cookies = new Cookies();

class Nav extends React.Component{

    menuItems;
    constructor(props) {
        super(props);
        this.props = props;

        this.menuItems = [];
        //this.menuItems.push(<a href={AppConfig.pages.admin.calls} className={"menuItem"}>Çağrılar</a>);
        this.menuItems.push(<a href={AppConfig.pages.admin.operators} className={"menuItem"}>Operatorler</a>);
        this.menuItems.push(<a href={AppConfig.pages.admin.newOperator} className={"menuItem"}>Yeni Operator</a>);
        this.menuItems.push(<a href={AppConfig.pages.admin.reports} className={"menuItem"}>Raporlar</a>);
    }


    logout(){
        globalSession.removeSession();
    }

    render() {
        return (
            <div id={"nav"}>
                <div>
                    <a href={AppConfig.pages.admin.home}><div id={"logo"}/></a>
                    <div id={"label"}>ÇAĞRI TAKİP SİSTEMİ</div>
                    <div id={"menu"}>
                        {this.menuItems}
                    </div>

                    <DropdownButton className={"rightMenu"}
                                    alignRight
                                    variant="light"
                                    title={cookies.get(AppConfig.cookie.name)+" "+cookies.get(AppConfig.cookie.surname)}
                                    id="dropdown-menu-align-right">
                        {/*<Dropdown.Item eventKey="1">Action</Dropdown.Item>
                    <Dropdown.Item eventKey="2">Another action</Dropdown.Item>
                    <Dropdown.Item eventKey="3">Something else here</Dropdown.Item>
                    <Dropdown.Divider />*/}
                        <Dropdown.Item eventKey="4" onClick={this.logout} id="logout">Çıkış Yap</Dropdown.Item>
                    </DropdownButton>


                </div>
            </div>
        )
    }
}

export default Nav;
